import { createContext } from 'react';
import type { PortalBranding } from '../services/brandingService';

export interface BrandingContextType {
  branding: PortalBranding | null;
  loading: boolean;
  getImageUrl: (url: string | null | undefined) => string | null;
}

export const BrandingContext = createContext<BrandingContextType | null>(null);

export const DEFAULT_BRANDING: PortalBranding = {
  logoUrl: null,
  faviconUrl: null,
  primaryColor: '#3B82F6',
  secondaryColor: '#1E40AF',
  companyName: null,
  tenantName: 'Musteri Portali',
};
